module.exports = __webpack_public_path__ + "img/italy-genitourinary-diseases-female.82df3e66.png";